export const useCrossNicheLinks = ({ crossNiche, agent_name }) => {
    const domainMap = {
        "lakehomes.com": "Lake Homes Realty",
        "beach-homes.com": "Beach Homes Realty",
        "mountainhomesrealty.com": "Mountain Homes Realty",
    };

    // Handle undefined or empty crossNiche
    if (!crossNiche || !Array.isArray(crossNiche)) {
        return { formattedLinks: [] };
    }

    const formattedLinks = crossNiche.reduce((acc, site) => {
        if (site.domain && site.path) {
            const siteName = domainMap[site.domain];
            if (siteName) {
                const href = `https://www.${site.domain}${site.path}`;
                const agentName = agent_name?.value?.split(" ")[0];
                const name = `View ${agentName}'s ${siteName} page`;
                return [...acc, { href, name, siteName }];
            }
        }
    }, []);
    return { formattedLinks };
};
